module.exports = __webpack_public_path__ + "media/water.957e6462.mp4";